module.exports = __webpack_public_path__ + "img/img1.abb47435.png";